export default "__VITE_ASSET__DZI66HiH__"